import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const styles = (theme:Theme) => {
  const cfg:any = {
  master: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    //width: 200,
  },
  hide:{
    display:'none',
  },
};
return cfg;
}

class FAutoIDField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value || 'fefd8a30-f375-4c2b-8ac8-f935d3789071'
    };
  }

  handleChange = (event:any) => {
    // let value = event.target.value;
    // this.props.onChange(value);
    // this.setState({value});
    const {onChange} = this.props;
    let value = event.target.value;
    this.setState({value});
    if(typeof onChange === 'function') onChange(value);
  };

  render() {
    //const {id,label,divider,classes } = this.props;
    const {id,label,required,options,divider,classes } = this.props;
    const {value} = this.state;
    
    return (
      //<div className={classes.master}>
        <React.Fragment>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            required={required}
            multiline={true}
            minRows={1}
            fullWidth={true}
            className={classes.textField}
            onChange={this.handleChange}
            value={value}
            {...options}
            //value={this.state.value}
            // inputProps={
            //   { readOnly: true, }
            // }
            //onChange={this.handleChange}
          />
        {divider && <Divider />}
        </React.Fragment>
      //</div>
    );
  }
}

FAutoIDField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FAutoIDField);
